import { type DocumentNode, gql } from '@apollo/client';

const deleteFieldDefMutation: DocumentNode = gql`
  mutation deleteFieldDefMutation($fieldDefId: ID!) {
    deleteFieldDef(fieldDefId: $fieldDefId) {
      success
    }
  }
`;

export default deleteFieldDefMutation;
